// pages/mind-mesch/Privacy.js

import React from 'react';

const Privacy = () => {
  return (
    <div style={{ padding: '2rem' }}>
      <h1>Privacy Policy</h1>
      <p>Your privacy is important to us. Mind Mesch adheres to strict data handling and encryption standards to protect your information.</p>

      <h3>What We Collect</h3>
      <p>We collect only the data necessary to deliver secure, personalized services — including name, email, preferences, and interaction history.</p>

      <h3>How It’s Used</h3>
      <p>Data is used solely to improve your experience. We never sell your data to third parties.</p>

      <h3>Your Rights</h3>
      <p>You can request to export or delete your data anytime. Just email us at <a href="mailto:privacy@mind-mesch.com">privacy@mind-mesch.com</a>.</p>
    </div>
  );
};

export default Privacy;
